import { Edit } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FuelAnalysiscolumnData } from "../../common/constants/gridRowColumn";
import {
  useCompany,
  useDealer,
  useFuelAnalysis,
  useMovableColumn,
  useNewVehicle,
  usePagination,
  useReplacement,
  useSortableColumn,
  useUser,
} from "../../common/hooks";
import { DeleteDialog } from "../../components/DeleteDialog";
import { SearchBar } from "../../components/SearchBar";
import { layoutStyle } from "../layout-ui/style";
import { TruckLoader } from "./truckLoader";
import { useDebounce } from "../../components/useDebounce";
import {
  actionColumnFunction,
  checkFieldColumn,
  checkbox,
  getDefaultColDef,
  sidebarMenu,
} from "../../common/constants/commonFunction";
import { getCompanyId } from "../../common/constants/commonFunction";
import { TAB_CONTENT, TAB_VALUE } from "../../common/constants/popupMessage";
import { localStorageItemNames } from "../../common/constants";
import { PageNameConstant } from "../../common/constants/PageNameConstant";
import { PopupBlock } from "../../components/PopupBlock";
import { onSortChanged } from "../../common/utils/sortingColumn";
import { columnSortingMessage } from "../../common/utils/columnSortingMessage";
import { SortingTextPopup } from "../../components/SortingTextPopup";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export const FuelAnalysis = () => {
  const classes = layoutStyle();
  const [page, setPage] = useState({ pageSize: 10000, page: 0 });
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [columnFinal, setColumnFinal] = useState([]);
  const [value, setValue] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowDataFinal, setRowDataFinal] = useState([]);
  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteValue, setDeleteValue] = useState();
  const { state } = useLocation();
  const navigation = useNavigate();
  const {
    getFuelAnalysisApi,
    fuelAnalysisList,
    deleteFuelAnalysisListByIdApi,
    getFuelAnalysisApiList,
    fuelListFilter,
    loading,
    setFuelListFilter,
  } = useFuelAnalysis();
  const { companyNameHeader, dealerNameHeader } = useCompany();
  const {
    setSelectedNav,
    columnChange,
    setColumnChange,
    popupBlock,
    setPopupBlock,
    setSidebarColumnPopup,
  } = useUser();

  const userType = localStorage.getItem("type");
  const defaultColDef = useMemo(() => getDefaultColDef(), []);
  const { setNewFleetNo } = useDealer();
  const { setToastClose } = useNewVehicle();
  const { setNewVehicle } = useNewVehicle();
  const { setReplacementList } = useReplacement();
  const gridRef = useRef(null);
  const [movableColumnData, setMovableColumnData] = useState([]);
  const {
    movableColumn,
    getMovableColumnApi,
    createMovableColumn,
    updateViewMovableColumn,
    sortedColumn,
    setSortedColumn,
  } = useMovableColumn();

  const {
    getSortableColumnApi,
    sortableColumnData,
    createSortableColumn,
    updateViewSortableColumn,
  } = useSortableColumn();
  const [nextButton, setNextButton] = useState("");
  const [prevButton, setPrevButton] = useState("");

  const handleClose = () => {
    setOpen(false);
    setValue(0);
  };
  useEffect(() => {
    getMovableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fuelAnalysis,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });

    getSortableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });
    setNewFleetNo(null);
    setNewVehicle([]);
    setSidebarColumnPopup("");
    setColumnChange(false);
  }, []);
  const onCellClicked = (event) => {
    let checkField = checkFieldColumn(event);
    if (checkField) {
      handleEditButton(event?.data);
    }
  };

  const [anchorElSearch, setAnchorElSearch] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [openSortingPopup, setOpenSortingPopup] = useState(false);
  const {
    setPagination,
    setFleetPagination,
    setMaintainancePagination,
    setFuelPagination,
    setFundingPagination,
  } = usePagination();

  const onSearch = (e) => {
    debouncedSearch(e?.target?.value);
    handleClickSearch(e);
  };
  const handleClickSearch = (event) => {
    setAnchorElSearch(event.currentTarget);
  };

  const onSearchFunc = (e) => {
    setSearchValue(e[0]);
  };
  const searchData = rowDataFinal?.filter((fuel) =>
    fuel?.fleetNo?.toLowerCase().includes(searchValue?.toLowerCase())
  );
  const debouncedSearch = useDebounce(onSearchFunc, 500);

  useEffect(() => {
    if (searchValue) {
      setRowDataFinal([...searchData]);
    } else if (fuelListFilter?.length > 0) {
      setRowDataFinal([...fuelListFilter]);
    }
  }, [searchValue, fuelListFilter]);
  useEffect(() => {
    if (sortedColumn?.length > 0) {
      const dataFinal = [];

      // Step 1: Add matching fleet numbers in the correct sequence
      sortedColumn.forEach((fleetNo) => {
        const match = fuelListFilter.find((item) => item.fleetNo === fleetNo);
        if (match) dataFinal.push(match);
      });

      // Step 2: Append remaining fleet numbers (not in sortedColumn)
      const remainingData = fuelListFilter.filter(
        (item) => !sortedColumn.includes(item.fleetNo)
      );

      dataFinal.push(...remainingData);
      setRowDataFinal([...dataFinal]);
    } else if (state?.data) {
      setRowDataFinal([...state.data]);
      setRows([...state.data]);
    } else {
      if (fuelListFilter?.length > 0) {
        setRowDataFinal(fuelListFilter);
      } else {
        setRowDataFinal([]);
      }
    }
  }, [fuelListFilter, state]);

  useEffect(() => {
    if (columns?.length > 0) {
      columns?.map((item) => {
        item["width"] = 160;
        return true;
      });
    }
  }, [columns]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${month}/${day}/${year}  ${hours}:${minutes}:${seconds}`;
  };
  useEffect(() => {
    if (sortableColumnData?.length > 0 && movableColumn?.length > 0) {
      let dataMovable = movableColumn[0];
      let columnParse = JSON.parse(dataMovable?.columnName);
      if (sortableColumnData?.length > 0) {
        columnParse?.map((item) => {
          if (
            item.field === sortableColumnData[0].sortedColumn &&
            sortableColumnData[0].pageName === PageNameConstant.fuelAnalysis
          ) {
            item["sort"] = sortableColumnData[0].direction;
          } else {
            item["sort"] = null;
          }
        });
      }
      setMovableColumnData(columnParse);
    } else if (movableColumn?.length > 0) {
      let dataMovable = movableColumn[0];
      let columnParse = JSON.parse(dataMovable?.columnName);
      setMovableColumnData(columnParse);
    } else {
      const actionColumn = actionColumnFunction({
        selectedRows: selectedRows,
        handleEditButton: handleEditButton,
        deleteButton: false,
      });

      const dateColumn = {
        field: "date",
        headerName: "Date",
        minWidth: 160,
        valueFormatter: (params) => formatDate(params.value),
      };
      setMovableColumnData([
        checkbox,
        ...FuelAnalysiscolumnData,
        dateColumn,
        actionColumn,
      ]);
    }
  }, [FuelAnalysiscolumnData, movableColumn]);

  useEffect(() => {
    if (movableColumnData) {
      setColumnFinal([...movableColumnData]);
    }
  }, [movableColumnData]);

  const handleAddButton = () => {
    navigation("/new-fleetlist", {
      state: {
        tabValue: TAB_VALUE.FLEET_LIST,
        selectedContent: TAB_CONTENT.FLEET_LIST,
      },
    });
  };
  const handleEditButton = (params) => {
    navigation("/new-fleetlist", {
      state: {
        tabValue: TAB_VALUE.FUEL_ANALYSIS,
        selectedContent: TAB_CONTENT.FUEL_ANALYSIS,
        data: params,
      },
    });
  };
  const handleDeleteButton = async (values) => {
    setDeleteOpen(true);
    setDeleteValue(values);
  };

  const handleDelete = async () => {
    const companyId = getCompanyId(userType, companyNameHeader);
    let payload = {
      id: deleteValue,
      companyId: companyId,
    };
    await deleteFuelAnalysisListByIdApi(payload);
    setDeleteOpen(false);
  };
  useEffect(() => {
    if (sortableColumnData?.length > 0) {
      let sortingColumnData = sortableColumnData[0]?.fleetDetails;
      let sortingValue = JSON.parse(sortingColumnData);
      setSortedColumn([...sortingValue]);
    }
  }, [sortableColumnData]);

  useEffect(() => {
    setToastClose(false);
    getMovableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fuelAnalysis,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });

    getSortableColumnApi({
      filter: {
        userId: localStorage.getItem(localStorageItemNames.userID),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      },
    });
    if (companyNameHeader) {
      const companyId = getCompanyId(userType, companyNameHeader);
      getFuelAnalysisApiList({
        fleetNo: "",
        companyId: companyId,
        dealerId: dealerNameHeader?.id,
      });
    } else {
      setFuelListFilter([]);
    }
  }, [companyNameHeader]);

  useEffect(() => {
    setPagination(0);
    setFleetPagination(0);
    setMaintainancePagination(0);
    setFuelPagination(0);
    setFundingPagination(0);
    setReplacementList([]);
    // getFuelAnalysisApi();
  }, []);

  const handleNext = (event) => {
    if (columnChange) {
      setPopupBlock(true);
      setNextButton("/funding-newvehicle");
    } else {
      setSelectedNav(sidebarMenu.newVehicle);
      navigation("/funding-newvehicle");
    }
  };
  const handleBack = () => {
    if (columnChange) {
      setPopupBlock(true);
      setPrevButton("/maintenance-analysis");
    } else {
      setSelectedNav(sidebarMenu.maintenance);
      navigation("/maintenance-analysis");
    }
  };
  const handleMovableColumn = async () => {
    const cols = gridRef.current?.api?.getAllGridColumns();
    const colNamesIndex = cols?.map((items, index) => items?.colDef);
    setMovableColumnData(colNamesIndex);
    if (movableColumn?.length > 0) {
      await updateViewMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fuelAnalysis,
        ColumnName: JSON.stringify(colNamesIndex),
        id: movableColumn[0]?.id,
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      });
    } else {
      await createMovableColumn({
        userId: localStorage.getItem(localStorageItemNames.userID),
        pageName: PageNameConstant.fuelAnalysis,
        ColumnName: JSON.stringify(colNamesIndex),
        companyId: localStorage.getItem(localStorageItemNames.companyId),
        dealerId: localStorage.getItem(localStorageItemNames.dealerId),
      });
    }
    setColumnChange(false);
  };
  const handleColumnChange = (event) => {
    if (event?.column) {
      const cols = gridRef.current?.api?.getAllGridColumns();
      const colNamesIndex = cols?.map((items, index) => items?.colDef);
      setMovableColumnData(colNamesIndex);
      setColumnChange(true);
    }
  };
  const onSortedColumnChange = () => {
    onSortChanged(
      gridRef,
      setSortedColumn,
      setColumnFinal,
      columnFinal,
      sortableColumnData,
      createSortableColumn,
      updateViewSortableColumn,
      PageNameConstant.fuelAnalysis
    );
  };
  const onSortedColumnChangeAlready = () => {
    setOpenSortingPopup(true);
  };
  return (
    <Box className={classes.mainContent}>
      <CustomTabPanel value={value} index={0}>
        <Box className={classes.gridContantFleetList}>
          <Stack
            direction="row"
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Box className={classes.headerNameText}>Fuel Analysis</Box>
            <Box className={classes.sortingFieldText}>
              {sortableColumnData &&
              sortableColumnData?.length > 0 &&
              sortableColumnData[0]?.direction
                ? columnSortingMessage(
                    sortableColumnData,
                    PageNameConstant.fuelAnalysis
                  )
                : ""}
            </Box>
          </Stack>
          <Stack
            direction="row"
            sx={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <Box className={classes.headerNameText}></Box>
            <Box className={classes.addEditGrid}>
              {sortableColumnData?.length === 0 ? (
                <Button
                  variant="outlined"
                  className={classes.fleetListNewButton}
                  onClick={onSortedColumnChange}
                >
                  <span style={{ fontSize: 12 }}>Save Sort</span>
                </Button>
              ) : (
                <Button
                  variant="outlined"
                  className={classes.fleetListNewButton}
                  onClick={onSortedColumnChangeAlready}
                >
                  <span style={{ fontSize: 12 }}>Save Sort</span>
                </Button>
              )}
              <Button
                variant="outlined"
                className={classes.fleetListNewButton}
                onClick={handleMovableColumn}
              >
                <span style={{ fontSize: 12 }}>Save Columns</span>
              </Button>
              <Button
                variant="outlined"
                className={classes.fleetListNewButton}
                onClick={handleBack}
              >
                <span style={{ fontSize: 12 }}>Back</span>
              </Button>
              <Button
                variant="outlined"
                className={classes.fleetListNewButton}
                onClick={handleNext}
              >
                <span style={{ fontSize: 12 }}>Next</span>
              </Button>
              <Button
                variant="outlined"
                className={classes.fleetListNewButton}
                onClick={handleAddButton}
              >
                NEW
              </Button>
              <SearchBar onSearch={onSearch} />
            </Box>
          </Stack>
          {loading ? (
            <TruckLoader />
          ) : (
            <AgGridReact
              ref={gridRef}
              className="ag-theme-quartz"
              rowSelection="multiple"
              onSelectionChanged={(event) => {
                const selectedNodes = event.api.getSelectedNodes();
                const selectedRows = selectedNodes.map((node) => node.data);
                setSelectedRows(selectedRows);
              }}
              suppressRowClickSelection
              pagination={true}
              rowData={rowDataFinal}
              defaultColDef={defaultColDef}
              checkboxSelection
              columnDefs={columnFinal}
              onCellClicked={onCellClicked}
              onColumnMoved={handleColumnChange}
            />
          )}
        </Box>
      </CustomTabPanel>
      {deleteOpen && (
        <DeleteDialog
          open={deleteOpen}
          setOpen={() => setDeleteOpen(false)}
          deleteApi={() => handleDelete()}
        />
      )}
      {popupBlock && (
        <PopupBlock
          open={popupBlock}
          setOpen={() => setPopupBlock(false)}
          navigationRouteNext={nextButton}
          navigationRoutePrev={prevButton}
          selectedNavStyle={
            nextButton ? sidebarMenu.newVehicle : sidebarMenu.maintenance
          }
          columnChangeData={movableColumnData}
          pageName={PageNameConstant.fuelAnalysis}
        />
      )}
      {openSortingPopup && (
        <SortingTextPopup
          open={openSortingPopup}
          setOpen={setOpenSortingPopup}
          gridRef={gridRef}
          setSortedColumn={setSortedColumn}
          setColumnFinal={setColumnFinal}
          columnFinal={columnFinal}
          sortableColumnData={sortableColumnData}
          createSortableColumn={createSortableColumn}
          updateViewSortableColumn={updateViewSortableColumn}
          pageName={PageNameConstant.fuelAnalysis}
        />
      )}
    </Box>
  );
};
